export const formatMetricCell = (cell, kind) => {
  if (!cell || cell.status === "empty" || cell.value == null) return "—";
  if (kind === "currency") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(cell.value);
  }
  if (kind === "currency2") {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cell.value);
  }
  if (kind === "ratio") {
    return Number(cell.value).toFixed(2);
  }
  return new Intl.NumberFormat("en-US").format(cell.value);
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

export const formatCount = (value) =>
  new Intl.NumberFormat("en-US").format(value || 0);

export const formatCompactCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value || 0);

/** Short status label for period availability (display only). */
export const periodAvailabilityLabel = (status) => {
  switch (status) {
    case "in_progress":
      return "In progress";
    case "upcoming":
      return "Upcoming";
    case "no_data":
      return "No data";
    case "data":
      return null;
    default:
      return null;
  }
};

const DOW = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

/** Display-only weekday for a YYYY-MM-DD business-day string. */
export const dayOfWeekLabel = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00`);
  return Number.isNaN(d.getTime()) ? "" : DOW[d.getDay()];
};

/** Display-only "Jul 05" style label for a YYYY-MM-DD string. */
export const shortDateLabel = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit" });
};
